var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAD9E"
    },
    d: "M230,0C102.974,0,0,102.974,0,230c0,103.909,68.906,191.725,163.517,220.245l289.267-277.629 C427.292,73.356,337.212,0,230,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6161"
    },
    d: "M452.783,172.616L320.333,40.167L119.146,405.854l44.376,44.375 C184.569,456.575,206.883,460,230,460c127.025,0,230-102.975,230-230C460,210.187,457.494,190.959,452.783,172.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M350.333,134.667v250c0,16.5-13.5,30-30,30h-90.01l-30-280L350.333,134.667L350.333,134.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#273B7A"
    },
    d: "M230.323,134.667v280h-89.99c-16.5,0-30-13.5-30-30v-250L230.323,134.667L230.323,134.667z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC61B"
    },
    points: "320.333,204.667 320.333,384.667 230.323,384.667 210.323,194.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEE187"
    },
    points: "230.323,194.667 230.323,384.667 140.333,384.667 140.333,204.667  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.667,
    y: 224.667,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.667,
    y: 278,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.667,
    y: 331.333,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 331.333,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 278,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 224.667,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.333,
    y: 224.667,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.333,
    y: 331.333,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.333,
    y: 278,
    style: {
      fill: "#273B7A"
    },
    width: 33.333,
    height: 33.333
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#366796"
    },
    points: "320.333,204.667 140.333,204.667 140.333,184.667 230.333,164.667 320.333,184.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "320.333,40.167 320.333,184.667 230.323,184.667 210.323,114.667 230.323,60.737  260.323,40.167 290.333,60.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "230.323,60.737 230.323,184.667 140.333,184.667 140.333,40.167 170.333,60.737  200.333,40.167  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.4ebda7d93135c41833acd9d245bf49f6.svg";
export { ForwardRef as ReactComponent };